import { BulkActionsApplicableAction } from "components/BulkActions/ChooseActionStep/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import {
  BulkActionItemID,
  BulkActionsActionsPerItem,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsDrawerActionStepsItems from "components/BulkActions/Drawer/ActionSteps/Items";
import BulkActionsPatternsActionsList from "components/BulkActionsPatterns/ActionsList";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

import FlowsProjectDetailsRolesBulkActionsSelectedItem from "./SelectedRoleItem";
import { FlowsProjectRolesBulkActions } from "./types";

type FlowsProjectDetailsRolesBulkActionsSelectedItemsViewProps = {
  items: FlowsProjectRoleBindingView[];
  onItemDismiss: (id: BulkActionItemID) => void;
  availableActions: Array<BulkActionsApplicableAction<FlowsProjectRolesBulkActions>>;
  actionsPerItem: BulkActionsActionsPerItem<FlowsProjectRolesBulkActions>;
  onEmptyActionsCancel: () => void;
};

const FlowsProjectDetailsRolesBulkActionsSelectedItemsView = ({
  items,
  onItemDismiss,
  actionsPerItem,
  availableActions,
  onEmptyActionsCancel,
}: FlowsProjectDetailsRolesBulkActionsSelectedItemsViewProps) => {
  return (
    <>
      <BulkActionsDrawerActionStepsItems selectedItemsCount={items.length}>
        {items.map((item) => (
          <FlowsProjectDetailsRolesBulkActionsSelectedItem
            key={item.id}
            item={item}
            onDismiss={onItemDismiss}
            itemActions={actionsPerItem.get(item.id)}
            allActionsQty={availableActions.length}
            step={BulkActionsStep.ChooseAction}
          />
        ))}
      </BulkActionsDrawerActionStepsItems>

      <BulkActionsDrawerActionStepsFooter>
        <BulkActionsPatternsActionsList
          variant={BulkActionsVariant.Drawer}
          availableActions={availableActions}
          onEmptyActionsCancel={onEmptyActionsCancel}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default FlowsProjectDetailsRolesBulkActionsSelectedItemsView;
